(function () {
    "use strict";

    angular
        .module("atheer.session")
        .controller("RemoveAssetLinkDialogController", RemoveAssetLinkDialogController);

    function RemoveAssetLinkDialogController($mdDialog) {
        var vm = this;

        vm.confirm = function () {
            $mdDialog.hide();
        };

        vm.cancel = function () {
            $mdDialog.cancel();
        };
    }
})();
